export const SEGMENT_CORRECTION_LABELS = {
    BUTTON_CLOSED: 'Ajustar data',
    LABEL_START_DATE: 'Nova data de início',
    BUTTON_SUBMIT: 'Enviar correção',
    BUTTON_CANCEL: 'Cancelar',
    BUTTON_SUBMITTING: 'Enviando...',
    ERROR_INVALID_DATE: 'Essa data não está disponível. Escolha um dia liberado no calendário.',
    ERROR_SUBMIT: 'Não foi possível enviar a correção. Tente de novo.',
    ERROR_PERMISSION: 'Não foi possível salvar a correção. Tente outra data ou fale com o DP.',
};

export function resolveCorrectionErrorMessage(error: unknown): string {
    const code = (error as { code?: string } | null)?.code;
    if (code === 'permission-denied') return SEGMENT_CORRECTION_LABELS.ERROR_PERMISSION;
    return SEGMENT_CORRECTION_LABELS.ERROR_SUBMIT;
}
